import { Link } from "react-router-dom";
import { Logo } from "./ui";
import { Phone, Mail, MessageCircle, Instagram, Facebook, Linkedin } from "lucide-react";

const WHATSAPP = "918084478504";
export const CONTACT_PHONE = "+91 80844 78504";
export const CONTACT_EMAIL = "info@sudigi.in";
export const SOCIALS = [
    { Icon: Instagram, href: "https://www.instagram.com/su_digi/", label: "Instagram" },
    { Icon: Facebook, href: "https://www.facebook.com/sudigi/", label: "Facebook" },
    { Icon: Linkedin, href: "https://www.linkedin.com/company/sudigi/", label: "LinkedIn" },
];

export function Footer() {
    return (
        <footer className="bg-teal-950 border-t border-brandborder/50 pt-16 pb-10 grain">
            <div className="container-x grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
                <div className="col-span-2 lg:col-span-2">
                    <Logo />
                    <p className="mt-4 text-cream-soft text-sm max-w-xs">Build Your Brand. Build Your Presence. Build Your Network. Discover the people, platforms and opportunities that can put your brand in the spotlight.</p>
                    <div className="flex gap-3 mt-5">
                        {SOCIALS.map(({ Icon, href, label }) => (
                            <a key={label} href={href} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-brandborder flex items-center justify-center text-cream-soft hover:text-gold hover:border-gold transition-colors" data-testid={`social-${label.toLowerCase()}`} aria-label={label}><Icon className="w-4 h-4" /></a>
                        ))}
                    </div>
                </div>
                <FooterCol title="Discover" links={[
                    ["Brands", "/brands"], ["Experts", "/experts"], ["Influencers", "/influencers"],
                    ["Podcasts", "/podcasts"], ["Events", "/events"], ["Opportunities", "/opportunities"],
                ]} />
                <FooterCol title="Marketing" links={[
                    ["Digital Marketing", "/marketing/digital-marketing"], ["SEO", "/marketing/seo"], ["Social Media", "/marketing/social-media"],
                    ["Reels & Video", "/marketing/reels"], ["Website", "/marketing/website"], ["PR & Media", "/marketing/pr-media"],
                ]} />
                <FooterCol title="Company" links={[["Build My Brand", "/build-my-brand"], ["Community", "/community"], ["Contact", "/contact"], ["Blog", "/resources"], ["Packages", "/packages"]]} />
                <div>
                    <h4 className="text-cream font-semibold mb-4 text-sm tracking-wide">Contact</h4>
                    <ul className="space-y-3 text-sm text-cream-soft">
                        <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-gold" /> <a href={`tel:${CONTACT_PHONE.replace(/ /g, "")}`} className="hover:text-gold">{CONTACT_PHONE}</a></li>
                        <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold" /> <a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-gold">{CONTACT_EMAIL}</a></li>
                        <li><button onClick={() => window.open(`https://wa.me/${WHATSAPP}`, "_blank")} className="flex items-center gap-2 hover:text-gold" data-testid="footer-whatsapp"><MessageCircle className="w-4 h-4 text-growth" /> Chat with us</button></li>
                    </ul>
                    <div className="mt-6">
                        <h4 className="text-cream font-semibold mb-3 text-sm tracking-wide">Legal</h4>
                        <ul className="space-y-2 text-sm text-cream-soft">
                            <li><Link to="/legal/privacy" className="hover:text-gold">Privacy Policy</Link></li>
                            <li><Link to="/legal/terms" className="hover:text-gold">Terms & Conditions</Link></li>
                            <li><Link to="/legal/refund" className="hover:text-gold">Refund Policy</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="container-x mt-12 pt-6 border-t border-brandborder/40 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-cream-soft">
                <p>© {new Date().getFullYear()} SUDIGI. All rights reserved.</p>
                <p>Digital Marketing. Simplified. Affordable. Result-Focused.</p>
            </div>
        </footer>
    );
}

function FooterCol({ title, links }) {
    return (
        <div>
            <h4 className="text-cream font-semibold mb-4 text-sm tracking-wide">{title}</h4>
            <ul className="space-y-2.5 text-sm text-cream-soft">
                {links.map(([label, to]) => <li key={label + to}><Link to={to} className="hover:text-gold transition-colors">{label}</Link></li>)}
            </ul>
        </div>
    );
}

export { WHATSAPP };
